module.exports = __webpack_public_path__ + "img/symbol_gray.76915df3.svg";